import { useQuery } from '@hooks/reactQuery';

import { viewMavenirConfig } from '@api/dataSources';

import { extractQueryParams } from '@utils/common';

import { refetchOptions } from '@constants/common';
import { MAVENIR_CONFIG_VIEW } from '@constants/queryKeys';

interface IMavenirConfigViewReturnType {
	configTree: string;
	isLoadingMavenirConfigTree: boolean;
}

const useQueryMavenirConfigView = (id?: string): IMavenirConfigViewReturnType => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [MAVENIR_CONFIG_VIEW, id],
		queryFn: extractQueryParams(viewMavenirConfig),
		enabled: [!!id],
		...refetchOptions,
	});

	return {
		configTree: data?.textJson || '',
		isLoadingMavenirConfigTree: isLoading || isFetching,
	};
};

export default useQueryMavenirConfigView;
